<template>
  <div class="booking-setting-page">
    <top-bar :topbarList="craftsmanTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { craftsmanIndexMixins } from "@/mixins/craftsmanIndexMixins";

export default {
  mixins: [craftsmanIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.booking-setting-page {
  height: 100%;
}
</style>
